import {
    GET_EMPLOYEEINFO_STARTED,
    GET_EMPLOYEEINFO_SUCESS,
    GET_EMPLOYEEINFO_FAILED
} from '../actions/Manageuser';
const intialData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};
export const employeeData = (state = intialData, action: any) => {
    switch (action.type) {
        case GET_EMPLOYEEINFO_STARTED:  
     return {
       ...state,
       items:[],
       isLoading: true,
     };
   case GET_EMPLOYEEINFO_SUCESS:
   // alert("GET_EMPLOYEEINFO_SUCESS action.payload");
   //  alert(JSON.stringify(action.payload));
     return {
       ...state,
       isLoading: false,
       status: action.status,
       items: action.payload
     };
   case GET_EMPLOYEEINFO_FAILED:
     return {
       ...state,
       isLoading: true,
     };
 default:
    return state;
}

}